class PostFilter {
	constructor(context) {
        this.context=context;
        this.input = this.context.createBiquadFilter();
        this.input.type = 'lowpass';
        this.input.Q.setValueAtTime(0,this.context.currentTime);
        this.output=this.context.createBiquadFilter();
        this.output.type="highpass";
        this.output.Q.setValueAtTime(0,this.context.currentTime);

		this.input.connect(this.output);

    }
    
    connect(output){
        this.output.connect(output)
    }

    disconnect(output){
        this.output.disconnect(output);
    }


	setParam = (filter,param,value) => {
        var node;
        if(filter==="LP"){
            node=this.input;
        }
        else if(filter==="HP"){
            node=this.output;
        }
        node[param].setValueAtTime(value,this.context.currentTime);
	};
}

export default PostFilter;